/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipes_AllInputs */

const en_recipes_all = /** @type {(inputs: Recipes_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All recipes`)
};

const de_recipes_all = /** @type {(inputs: Recipes_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Rezepte`)
};

/**
* | output |
* | --- |
* | "All recipes" |
*
* @param {Recipes_AllInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipes_all = /** @type {((inputs?: Recipes_AllInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipes_AllInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipes_all(inputs)
	return en_recipes_all(inputs)
});